import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import pluralize from 'pluralize';

import { getUserRoles } from 'utils/userRolesUtils';
import {
  homeDashboardOverviewLoadingSelector,
  summaryActiveAssignmentsDataSelector,
} from 'redux/selectors/homeDashboardSelectors';
import { UserRole } from 'enums';
import Accessor from 'components/Accessor';
import DashboardTab, { ChartImageType } from './DashboardTab';
import { getMyActiveAssignments } from 'redux/reducers/homeDashboardSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';

import styles from './DashboardTabs.module.less';

export enum DashboardTabsEnum {
  Preferred = 'preferred',
  Summary = 'summary',
  Financials = 'financials',
}

type Props = {
  activeTab: DashboardTabsEnum;
};

const REPORTS_AVAILABLE_COUNT = 6;

export default function DashboardTabs(props: Props) {
  const { activeTab } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isOverviewLoading = useAppSelector(
    homeDashboardOverviewLoadingSelector,
  );
  const summaryActiveAssignmentsData = useAppSelector(
    summaryActiveAssignmentsDataSelector,
  );
  const activeAssignmentTotalCount =
    summaryActiveAssignmentsData?.activeAssignmentTotalCount || 0;

  useEffect(() => {
    dispatch(getMyActiveAssignments());
  }, [dispatch]);

  const handleTabChange = (tab: DashboardTabsEnum) => {
    navigate(`/?section=${tab}`, { replace: true });
  };

  return (
    <div className={styles.wrap}>
      {/* was hidden in scope of https://mybasepay.atlassian.net/browse/MBO-975 */}
      {/* <Col xs={12} md={6} className="d-flex">
          <DashboardTab
            isActive={activeTab === DashboardTabsEnum.Preferred}
            title="Preferred"
            detailsTitle=""
            detailsSubTitle=""
            onClick={() => handleTabChange(DashboardTabsEnum.Preferred)}
          />
        </Col> */}

      <div className="d-flex">
        <DashboardTab
          isActive={activeTab === DashboardTabsEnum.Summary}
          title="Summary"
          detailsTitle={activeAssignmentTotalCount}
          detailsSubTitle={`active ${pluralize(
            'assignment',
            activeAssignmentTotalCount,
          )}`}
          onClick={() => handleTabChange(DashboardTabsEnum.Summary)}
          loading={isOverviewLoading}
        />
      </div>
      <Accessor
        roles={getUserRoles(UserRole.RecruiterCompany)}
        teammateRoles={getUserRoles(UserRole.TeammateAdmin)}
      >
        <div className="d-flex">
          <DashboardTab
            title="Financials"
            chartImageType={ChartImageType.PieChart}
            detailsTitle={REPORTS_AVAILABLE_COUNT}
            isActive={activeTab === DashboardTabsEnum.Financials}
            detailsSubTitle={`${pluralize(
              'Report',
              REPORTS_AVAILABLE_COUNT,
            )} available`}
            onClick={() => handleTabChange(DashboardTabsEnum.Financials)}
          />
        </div>
      </Accessor>
    </div>
  );
}
